// ProfileCategories.js
'use strict';
import { connect } from 'react-redux';

import ProfileCategories from '../component/ProfileCategories.jsx';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getIsCategoryEmpty from '../selector/getIsCategoryEmpty.js';
import getProfileFeedUnixTimestamp from '../selector/getProfileFeedUnixTimestamp.js';
import getMeData from '../selector/getMeData.js';
import getUserData from '../selector/getUserData.js';

const mapStateToProps = (state, { userId, remoteConfigKey }) => {
  const categories = getRemoteConfigData(state, remoteConfigKey, undefined, {
    USER_ID: userId,
  });
  const meId = getMeData(state, 'id');
  const username = getUserData(state, userId, 'username');
  return {
    isFetchedAndEmpty: getIsCategoryEmpty(state, categories),
    categoryTemplates: getRemoteConfigData(state, remoteConfigKey),
    profileFeedUnixTimestamp: getProfileFeedUnixTimestamp(state, meId),
    categories,
    username,
  };
};

export default connect(mapStateToProps, null)(ProfileCategories);
